// import { createSlice } from "@reduxjs/toolkit";
// import { updateBusiness} from './thunk';
// export const initialState :any= {
//   business: [],
//   error: {},
// };

// const BusinessSlice = createSlice({
//   name: 'BusinessSlice',
//   initialState,
//   reducers: {},
//   extraReducers: (builder) => {
  

//     builder.addCase(updateBusiness.fulfilled, (state:any, action:any) => {
//       state.businessies = state.businessies.map((business:any) =>
//         business.id === action.payload.id
//           ? { ...business, ...action.payload }
//           : business
//       );;
//     });

//     builder.addCase(updateBusiness.rejected, (state:any, action:any) => {
//       state.error = action.payload.error || null;
//     });

//   }
// });

// export default BusinessSlice.reducer;


import { createSlice } from "@reduxjs/toolkit";
import { businessBySellerId, getBank, getSeller, setSeller, updateAddress, updateBankInformation } from "./thunk";
import { Constant } from "utils/enums";

interface MetaData {
  height: number;
  width: number;
  fileType: string;
  fileFormat: string;
  name: string;
  duration: number;
}

interface Document {
  url: string;
  metaData: MetaData;
}

interface IDBankDetails {
  businessDocuments: Document[];
  companyLegalName: string;
  businessRegistrationNumber: string;
  bankDocuments: Document[];
  accountName: string;
  accountNumber: string;
  Iban: string;
  bank: string;
  bankCode: string;
  bankBranch: string;
  swift: string;
}

interface PersonInCharge {
  personInCharge: string;
  personInChargeEmail: string;
  personInChargePhoneNumber: string;
}

interface Nationality {
  cnicFrontImage: string;
  cnicBackImage: string;
  cnicNumber: string;
  cnicName: string;
}

interface Address {
  streetAddress: string;
  type: string;
  coordinates: string[]; 
  zip: string;
  city: string;
  state: string;
  stateId?: string;
  cityId?: string;
  zoneId?: string;
  isPlaza?: boolean;
  plazaMarketName?: string;
  shopName?: string;
  shopNumber?: string;
}


interface Holiday {
  holidayMode: boolean;
  holidayModePeriod: string;
}

export class Business {
  _id: string="";
  accountType: string="";
  sellerType: string="";
  storeName: string="";
  firstName: string="";
  lastName: string="";
  email: string="";
  idBankDetails?: IDBankDetails;
  country: string="";
  personInCharge?: PersonInCharge;
  nationality?: Nationality;
  address?: Address;
  holiday?: Holiday;
  authorizedPersonId: Document[]=[];
  authorizedPersonCertificate: Document[]=[];

}
// let initialBusiness = JSON.parse(sessionStorage.getItem(Constant.seller) || "");
let storedData = localStorage.getItem(Constant.seller);
let initialBusiness = storedData && storedData.trim() !== "" ? JSON.parse(storedData) : {};

const initialState: any = {
  business:  initialBusiness?? new Business(),
  bank:[]
  
};

const businessSlice = createSlice({
  name: "business",
  initialState,
  reducers: {
    // updateBusiness(state, action: PayloadAction<Partial<Business>>) {
    //   Object.assign(state, action.payload);
    // },
    resetBusinessState() {
      return initialState;
    },
  },
  extraReducers: (builder) => {

    builder.addCase(setSeller.fulfilled, (state: any, action: any) => {
      state.business = action.payload;
      localStorage.setItem(Constant.seller, JSON.stringify(action.payload));

    });
    builder.addCase(updateAddress.fulfilled, (state: any, action: any) => {
      state.business = action.payload;
    });
    builder.addCase(updateBankInformation.fulfilled, (state: any, action: any) => {
      state.business = action.payload;
    });
    builder.addCase(businessBySellerId.fulfilled, (state: any, action: any) => {
      if (action.payload && action.payload.isSuccess) {
        state.business = action.payload.data;
        localStorage.setItem(Constant.seller, JSON.stringify(action.payload.data));
      }
    })
      .addCase(getSeller.fulfilled, (state: any, action: any) => {
        state.business = action.payload;
        localStorage.setItem(Constant.seller, JSON.stringify(action.payload));
      })

    builder.addCase(getBank.fulfilled, (state: any, action: any) => {
      state.bank = action.payload
  });

  builder.addCase(getBank.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
  });
  }
});

export const {  resetBusinessState } = businessSlice.actions;

export default businessSlice.reducer;
